import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FilterDataService } from '../filter-data.service';

@Component({
  standalone: false,
  selector: 'app-filter-menu',
  templateUrl: './filter-menu.component.html',
  styleUrls: ['./filter-menu.component.scss']
})
export class FilterMenuComponent implements OnInit {

  constructor(public dataService: FilterDataService) {}

  @Input() menuContent: any[]; // Type and menu items to be displayed
  @Input() filterValues: any[]; // Elements to be filtered.
  @Output() closeMenu = new EventEmitter<any>(); 
  @Output() filtersSelected = new EventEmitter<any>();

  ngOnInit() { 
    this.dataService.toFilterArray = this.filterValues;
    for(let item of this.menuContent) {
        this.dataService.masterArray.push({'Name': item.name,'Filters': []});
        // If the filter type is an input, the possible options are stored to be shown to the user in the dropdown.
        this.dataService.inputValues.set(item.col, new Set<any>());
        item.mode == "input" ? this.dataService.initializeInput(item.col) : 
                               this.dataService.getMinDate(item.col);
    }
  }

  /**
   * Updates the menu to show the selected filter, if the filter is already selected it will close.
   * 
   * @param index Menu position of the item to be opened/closed.
   */
  collapse (index: number) {
    this.dataService.collapsed = (index == this.dataService.collapsed) ? -1 : index;
  }

  /**
   * Communicates with the parent to close the menu and removes active filters.
   */
  closeMenuEvent() {
    this.closeMenu.emit();
  }

  /**
   * Sends the filters selected by the user to the parent.
   */
  sendFilters() {
    this.filtersSelected.emit(this.getFinalArray());
  }

  /**
   * Transforms the array with the filters chosen by the user into a Map if they exists.
   */
  getFinalArray(): Map<String, Set<any>>{
    let finalArray = new Map<string, Set<any>>();
    
    for(let [i, item] of this.menuContent.entries()) {
      if(this.dataService.masterArray[i].Filters.length > 0) finalArray.set(item.col, new Set<any>(this.dataService.masterArray[i].Filters));
    }
    return finalArray;
  }
}
